export const config = {
    api_root: 'https://dinereserve.diningtek.biz/api'
};
